function assessEmails(profile) {
  const affiliationLookup = Object.fromEntries(
    profile.affiliation_summary.map((affiliation) => [
      affiliation.affiliation_id,
      affiliation,
    ])
  );

  const emails = profile.email_addresses.map((email) => {
    return { ...email };
  });

  emails.forEach((email) => {
    if (email.affiliation_id) {
      const affiliation = affiliationLookup[email.affiliation_id] || {};
      email.institution = affiliation.institution_name;
      email.affiliation_ended = affiliation.last_valid_on;
      email.last_valid_on = email.valid_through || affiliation.last_valid_on;
    } else email.last_valid_on = email.valid_through;
  });

  const [primaryEmail] = emails
    .filter(
      (email) =>
        profile.primary_email_address &&
        email.id === profile.primary_email_address.id &&
        !email.last_valid_on
    )
    .map((email) => {
      return { ...email, isPrimary: true };
    });

  const primaryEmailId = primaryEmail ? primaryEmail.id : null;
  const alternateEmails = emails
    .filter((email) => email.id !== primaryEmailId && !email.last_valid_on)
    .map((email) => {
      return { ...email, isAlternate: true, noPrimary: !primaryEmail };
    });

  const oldEmails = emails
    .filter((email) => email.last_valid_on)
    .map((email) => {
      return { ...email, isOld: true, noPrimary: !primaryEmail };
    });

  const personInfo = {
    affiliationLookup,
    affiliations: profile.affiliation_summary,
    fullName: profile.full_name,
  };

  return {
    emails,
    primaryEmail,
    alternateEmails,
    oldEmails,
    personInfo,
  };
}

export default assessEmails;
